module.exports = __webpack_public_path__ + "portal-static/img/4.fcde9109.jpg";